import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BugReport } from '@mui/icons-material';
import { useSelector } from "react-redux";
import { BackButton, TableData, TxnLogView } from "components";
import { getTransactionsService, getLogsTxnService, getTransactionsIdsService } from "services/panelService";
import { setErrorCodesHistoryIdsProvider } from 'redux/slices/admin/providerSlice';
import { validatePermission } from 'helpers/authentication';
import { useNavigate } from "react-router-dom";
import DialogModal from "components/modal/DialogModal";

const PanelTransactionsScreen = ({ slim = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [stop, setStop] = useState(false)
  const { token } = useSelector(store => store.session)
  const { hebeErrorCodesHistoryListIds } = useSelector(store => store.providers)
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' })
  const shortList = new Array(15).fill({});
  let timer;

  useEffect(() => {
    if (token) {
      setStop(false)
      setLoading(true)
      if (hebeErrorCodesHistoryListIds && hebeErrorCodesHistoryListIds.length > 0) {
        getTransactionsIdsService(hebeErrorCodesHistoryListIds).then((response) => {
          dispatch(setErrorCodesHistoryIdsProvider(null));
          setList(response);
        }).finally(() => setLoading(false))
      } else {
        getData();
      }
    }
    return () => {
      setStop(true);
      clearTimeout(timer);
    }
    // eslint-disable-next-line
  }, []);

  const getData = () => {
    getTransactionsService(0, 300).then((response) => {
      setList(response);
      // timer = setTimeout(() => {
      //   if (!stop)
      //     getData();
      // }, 3000);
    }).finally(() => setLoading(false))
  }

  return (
    <>
      {!slim && <BackButton name={'Regresar'} click={() => navigate(-1)} />}
      <TableData
        title={"Transacciones"}
        onTitleClick={() => slim && navigate('../transacciones')}
        maxHeight="40vh"
        autonumber={false}
        pagination={!slim}
        loading={loading}
        rowsPerPageOpt={50}
        headerStyle={slim && {
          fontSize: slim ? 11 : 16,
        }}
        dataRows={(slim ? shortList.map((item, i) => list[i] || {}) : list).map((item) => ({
          ...item,
          style: {
            color: item.ProviderResponseCode != "00" && 'red',
            fontSize: slim ? 11 : 14,
          }
        }))}
        dataTitle={[
          "Hora",
          !slim && "Bolsa",
          !slim && "Tipo",
          "Operadora",
          !slim && "Producto",
          "Monto",
          "Número",
          "Código",
          !slim && "Estado",
          !slim && "Tiempo (ms)",
        ].filter(Boolean)}
        formatter={({
          typeReg,
          createdAt,
          hosterBagId,
          operator,
          amount,
          phoneNumber,
          reference,
          referenceSaldo,
          productId,
          productType,
          ProviderResponseCode,
          ProviderResponseMessage,
          time
        }) => ([
          createdAt ? moment(createdAt).format(slim ? 'HH:mm:ss' : 'DD/MM/YY HH:mm:ss') : '-',
          !slim && (hosterBagId?.hashtag || '-'),
          !slim && (typeReg || '-'),
          operator || '-',
          !slim && (['PDS', 'PIN'].includes(typeReg) ? (productType || '-') : productId || '-'),
          slim ? (amount || '-') : `$ ${Number(amount || 0).toFixed(2)}`,
          (['PDS', 'PIN'].includes(typeReg) ? (reference || referenceSaldo || '-') : phoneNumber || '-'),
          ProviderResponseCode || '-',
          !slim && { type: 'text', value: ProviderResponseMessage || '-' },
          !slim && (time || '-'),
        ].filter(Boolean))}
        actions={[
          !slim && validatePermission('proveedores', 'proveedores', ['agregar']) && {
            label: "Logs",
            icon: <BugReport />,
            onClick: async (data) => {
              const result = await getLogsTxnService(data.id);
              setDialog({
                open: true,
                maxWidth: 'lg',
                title: `Log Transacción ${data.id}`,
                textAlign: 'left',
                body: <TxnLogView data={result} />,
                onClose: () => setDialog({ open: false })
              });
            },
          },
        ].filter(Boolean)}
      />
      <DialogModal
        open={dialog.open}
        title={dialog.title}
        body={dialog.body}
        maxWidth={dialog.maxWidth}
        textAlign={dialog.textAlign}
        onClose={dialog.onClose}
      />
    </>

  );
};

export default PanelTransactionsScreen;
